<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20 ">
			<div class="title_shaixuan flex_jc_center">综合筛选</div>
			<div>
				<el-form :inline="true" :model="formData" class="demo-form-inline">
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.workersize" placeholder="工人数量">
							<el-option v-for="(item, index) in workersize" :key="index" :label="item.name" :value="item.no">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="select-inputs">
						<el-select size="small" v-model="formData.qualification" placeholder="拥有资质">
							<el-option v-for="(item, index) in data" :key="index" :label="item.name" :value="item.no">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
  const url = process.env.VUE_APP_LOGINAPI;
  import request from "@/http";
	export default {
		name: "laborScreen",
    data() {
      return {
        data:[],
        workersize: [
          { name: "0-10人", no: 0 },
          { name: "11-50人", no: 1 },
          { name: "51-100人", no: 2},
          { name: "101-200人", no: 3},
          { name: "200人以上", no: 4}
        ],
        formData:{
          workersize:'',
          qualification:''
        }
      }
    },
    watch:{
      'formData.workersize':function (v){
        let obj=this.workersize.filter(d=>d.no==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'workersize')
        }
      },
      'formData.qualification':function (v){
        let obj=this.data.filter(d=>d.no==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'qualification')
        }
      },
    },
    created() {
		  this.getClassification()
    },
    methods: {
      /** @name 获取拥有资质 */
      async getClassification() {
       let res = await request.get(url + "/sgb-enterpriseservices/qualificationNameConfig/all",);
       this.data= res.data.data
      },
      /** @name 搜索单项 */
      send(obj,key){
        if(key)obj.key=key;
        //替换搜索项
        let type=-1;
        this.$parent.$refs.screen.laborScreen.map((d,i)=>{
          if(d.key==key){
            type=i
          }
        });
        if(type>-1) {
          this.$parent.$refs.screen.laborScreen.splice(type,1,obj)
          return
        }
        //添加搜索项
        this.$parent.$refs.screen.laborScreen.push(obj)
      },
      /** @name 清队单项 */
      close(item){
        this.formData[item.key]=''
      },
      /** @name 清空所有 */
      closeall(){
        this.formData={
         workersize:'',
         qualification:''
        }
      }
    },
	}
</script>

<style lang="scss" scoped>
.select-inputs{
  height: 30px;
  margin-top: 10px;
  margin-left: 10px;
  /deep/.el-input__inner{
    width: 200px!important;
  }
}

</style>
